import { useEffect, useRef, useState } from 'react';
import { times, throttle } from 'lodash';
import Regional from '../Regional';
import Products from '../Products';
import Reddit from '../Reddit';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TAB_NUMS = 3;

export default function JoinUsNow() {
    const { t } = useLang('communitylang.joinUsNow');

    const [activeTab, setActiveTab] = useState('0');
    const tabRef = useRef<HTMLDivElement | null>(null);
    const menuRef = useRef<HTMLDivElement | null>(null);
    const gapRef = useRef<HTMLDivElement | null>(null);
    const stickyRef = useRef<HTMLDivElement | null>(null);

    const tabs = times(TAB_NUMS, (i) => ({
        key: `${i}`,
        name: t(`tab_${i + 1}`),
    }));

    const refArr: any[] = [];
    for (let i = 0; i < TAB_NUMS; i++) {
        refArr.push(useRef(null));
    }

    const clickTab = (key: string) => {
        if (key !== activeTab) {
            setActiveTab(key);
            refArr[key as keyof typeof refArr]?.current?.scrollIntoView();
        }
    };

    const changeTabLine = throttle(() => {
        const dom: any = menuRef.current;
        const gapDom: any = gapRef.current;
        const stickyDom: any = stickyRef.current;

        const { top }: any = dom?.getBoundingClientRect();
        const { top: gapTop }: any = gapDom?.getBoundingClientRect();

        stickyDom.style.visibility = gapTop < 0 ? 'visible' : 'hidden';

        dom.style.display = !!top ? 'inline-flex' : 'flex';
        for (let i = 0; i < refArr.length; i++) {
            const position: Record<string, string | number> = refArr[i].current?.getBoundingClientRect();
            if (position.top <= 0 && position.bottom >= 1) {
                setActiveTab(`${i}`);
            }
        }
    }, 1000 / 60);

    useEffect(() => {
        window.addEventListener('scroll', changeTabLine);
        return () => {
            window.removeEventListener('scroll', changeTabLine);
        };
    }, []);

    return (
        <div className={`joinUsNow ${css.joinUsNow}`}>
            <div className="join-gap" ref={gapRef}>
                <p className="gap-text">{t('gap_title')}</p>
            </div>
            <div className="tabs-box" ref={tabRef}>
                <div className="menu-box" ref={stickyRef}>
                    <div className="tabs-menu" ref={menuRef}>
                        {tabs.map((item) => (
                            <div key={item.key} className={`tab-item ${item.key === activeTab ? 'active-tab' : ''}`} onClick={() => clickTab(item.key)}>
                                {item.name}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="content-box">
                    <div className="tab-content">
                        <div ref={refArr[0]}>
                            <Regional />
                        </div>
                        <div ref={refArr[1]}>
                            <Products />
                        </div>
                        <div ref={refArr[2]}>
                            <Reddit />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
